import { AnimatePresence } from "framer-motion"
import { Suspense } from "react"
import { createBrowserRouter, Route, Routes, useLocation } from "react-router-dom"
import { AboutPage } from "@/pages/about"
import { BeginnerPathPage } from "@/pages/beginner-path"
import { LibraryPage } from "@/pages/library"
import { NichePage } from "@/pages/niche"
import { PostDetailPage } from "@/pages/post-detail"
import { PostTypePage } from "@/pages/post-type"
import { PostsPage } from "@/pages/posts"
import { ReferralPage } from "@/pages/referral"
import { SearchPage } from "@/pages/search"
import { TopicPage } from "@/pages/topic"
import { Layout } from "@/widgets/app-layout"
import { ClientErrorReporter } from "../providers/client-error-reporter"

function AppRoutes() {
	const location = useLocation()
	return (
		<>
			<ClientErrorReporter />
			<Layout>
				<Suspense
					fallback={
						<div role="status" className="p-8 text-muted-foreground">
							Загружаем раздел…
						</div>
					}
				>
					<AnimatePresence mode="wait" initial={false}>
						<Routes location={location} key={location.pathname}>
							<Route path="/" element={<PostsPage />} />
							<Route path="/beginner-path" element={<BeginnerPathPage />} />
							<Route path="/f/:id" element={<PostTypePage />} />
							<Route path="/t/:id" element={<TopicPage />} />
							<Route path="/n/:id" element={<NichePage />} />
							<Route path="/post/:id" element={<PostDetailPage />} />
							<Route path="/about" element={<AboutPage />} />
							<Route path="/referral" element={<ReferralPage />} />
							<Route path="/search" element={<SearchPage />} />
							<Route path="/library" element={<LibraryPage />} />
						</Routes>
					</AnimatePresence>
				</Suspense>
			</Layout>
		</>
	)
}

export const router = createBrowserRouter([{ path: "*", element: <AppRoutes /> }])
